import { ColDef } from "ag-grid-community";
import { agFilterNames } from "../../../shared/types/AgFilterNames";
import { sharedColNames, dateComparator, dateComparatorForFilter, currencyComparator, amountColumnTemplate } from "../transactions-table/table-helpers";
import { Constants } from "../../../shared/utilities/Constants";

const colNames = {
  actions: sharedColNames.actions,
  accountNumber: 'Account number',
  accountName: 'Account name',
  registrationType: 'Registration type',
  processDate: 'Process date',
  nextProcessDate: 'Next process date',
  dateRange: 'Date',
  transactionType: sharedColNames.transactionType,
  toFromAccount: sharedColNames.toFromAccount,
  direction: 'Direction',
  amount: 'Amount',
  availableCash: 'Available cash',
  status: 'Status',
  activityReportDownload: 'ActivityReportDownload'
}
  const availableCashToolTipText: string = Constants.availableCash;

export const defaultMasterTransactionsTabColumnDefs: ColDef[] = [
  {
    field: colNames.accountNumber,
    sortIndex: 0,
    sort: 'asc',
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 140,
  },
  {
    field: colNames.accountName,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 140
  },
  {
    field: colNames.registrationType,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.processDate,
    comparator: dateComparator,
    filter: agFilterNames.date,
    filterParams: {
      comparator: dateComparatorForFilter,
      inRangeInclusive: true,
      browserDatePicker: true
    },
    minWidth: 160,
    maxWidth: 160
  },
  {
    field: colNames.transactionType,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.toFromAccount,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.direction,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.amount,
    sortIndex: 1,
    comparator: currencyComparator,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    type: 'rightAligned',
    headerComponentParams: { template: amountColumnTemplate },
    minWidth: 120
  },
  // {
  //   headerTooltip: availableCashToolTipText,
  //   field: colNames.availableCash,
  //   comparator: currencyComparator,
  //   floatingFilterComponent: 'customTextFloatingFilter',
  //   floatingFilterComponentParams: {
  //     suppressFilterButton: true,
  //   },
  //   type: 'rightAligned',
  //   headerComponentParams: { template: amountColumnTemplate },
  //   minWidth: 120
  // },
  {
    field: colNames.status,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    minWidth: 140
  }
];

export const defaultMasterRecurringTabColumnDefs: ColDef[] = [
  {
    field: colNames.accountNumber,
    sortIndex: 1,
    sort: 'asc',
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 140
  },
  {
    field: colNames.accountName,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 140
  },
  {
    field: colNames.registrationType,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.nextProcessDate,
    sortIndex: 0,
    comparator: dateComparator,
    filter: agFilterNames.date,
    filterParams: {
      comparator: dateComparatorForFilter,
      inRangeInclusive: true,
      browserDatePicker: true
    },
    minWidth: 160,
    maxWidth: 160
  },
  {
    field: colNames.transactionType,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.toFromAccount,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.direction,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.amount,
    sort: null,
    comparator: currencyComparator,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    type: 'rightAligned',
    headerComponentParams: { template: amountColumnTemplate },
    minWidth: 120
  },
  // {
  //   field: colNames.availableCash,
  //   comparator: currencyComparator,
  //   floatingFilterComponent: 'customTextFloatingFilter',
  //   floatingFilterComponentParams: {
  //     suppressFilterButton: true,
  //   },
  //   type: 'rightAligned',
  //   headerComponentParams: { template: amountColumnTemplate },
  //   minWidth: 120
  // },
  {
    field: 'Frequency',
    filter: agFilterNames.set,

    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    minWidth: 120,
    width: 120,
    maxWidth: 130
  }

];

export const defaultMasterActivityReportTabColumnDefs: ColDef[] = [
  {
    field: colNames.dateRange,
    sortable: false,
    filter: false,
    minWidth: 260,
    maxWidth: 260,
    floatingFilter: false,
      floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  }
];